import React from 'react';
import { Button } from 'Permafrost/index';
import { StyledSaveCancel } from './SaveCancel.styles';
export function SaveCancel(props) {
    const { className, id, disableSave, handleCancel, handleSave } = props;
    return (React.createElement(StyledSaveCancel, { className: className, "data-cy": props['data-cy'], id: id },
        React.createElement("hr", null),
        React.createElement("div", null,
            React.createElement(Button, { onClick: handleSave, variant: "cta", className: "saveButton", disabled: disableSave }, "Save"),
            React.createElement(Button, { onClick: handleCancel, variant: "link-style", className: "cancelButton" }, "Cancel"))));
}
//# sourceMappingURL=SaveCancel.js.map